import React from 'react'
import cx from 'classnames'

import InlineSvg from 'components/_new/ui/InlineSvg/InlineSvg'

import s from './Icon.scss'

import amazonIcon from './images/amazon.svg'
import appleIcon from './images/apple.svg'
import bottomArrowSmallIcon from './images/bottom-arrow-small.svg'
import checkmarkIcon from './images/checkmark.svg'
import checkmarkInCircleIcon from './images/checkmark-in-circle.svg'
import checkmarkInEmptyCircleIcon from './images/checkmark-in-empty-circle.svg'
import checkmarkLongIcon from './images/checkmark-long.svg'
import checkmarkLightIcon from './images/checkmark-light.svg'
import circleInCircleIcon from './images/circle-in-circle.svg'
import closeLightIcon from './images/close.svg'
import creditCardIcon from './images/credit-card.svg'
import dislikeIcon from './images/dislike.svg'
import facebookIcon from './images/facebook.svg'
import facebookCircleIcon from './images/facebook-circle.svg'
import googleIcon from './images/google.svg'
import heartIcon from './images/heart.svg'
import infoInCircleIcon from './images/info-in-circle.svg'
import infoInCircleFilledIcon from './images/info-in-circle-filled.svg'
import leftArrowIcon from './images/left-arrow.svg'
import leftArrowSmallIcon from './images/left-arrow-small.svg'
import likeIcon from './images/like.svg'
import lockIcon from './images/lock.svg'
import lockWithKeyHoleIcon from './images/lockWithKeyHole.svg'
import paypalIcon from './images/paypal.svg'
import paypalLightIcon from './images/paypal-light.svg'
import pencilIcon from './images/pencil.svg'
import playIcon from './images/play.svg'
import plusIcon from './images/plus.svg'
import plusInCircleIcon from './images/plus-in-circle.svg'
import plusLightIcon from './images/plus-light.svg'
import questionIcon from './images/question.svg'
import replayIcon from './images/replay.svg'
import rightArrowIcon from './images/right-arrow.svg'
import rightArrowSmallIcon from './images/right-arrow-small.svg'
import searchIcon from './images/search.svg'
import timesIcon from './images/times.svg'
import truckIcon from './images/truck.svg'
import linkIcon from './images/link.svg'
import messengerIcon from './images/messenger.svg'
import smsIcon from './images/sms.svg'
import smsMessengerIcon from './images/sms-messenger.svg'
import starIcon from './images/star.svg'
import copyIcon from './images/copy.svg'
import newWindowIcon from './images/new-window.svg'
import whatsAppIcon from './images/whatsApp.svg'
import filledEmptyCircleIcon from './images/filled-empty-circle.svg'
import cancelIcon from './images/cancel.svg'
import swapFragranceIcon from './images/swap-fragrance.svg'
import freeCalendarIcon from './images/free-calendar.svg'
import safeCheckoutIcon from './images/safe-checkout.svg'
import stopIcon from './images/stop.svg'
import thumbsUpIcon from './images/thumbs-up.svg'
import thumbsUpSmallIcon from './images/thumbs-up-small.svg'
import thumbsDownIcon from './images/thumbs-down.svg'
import thumbsDownSmallIcon from './images/thumbs-down-small.svg'
import freeCaseIcon from './images/freeCase.svg'
import travelSizeIcon from './images/travelSize.svg'
import freeShippingIcon from './images/freeShipping.svg'
import noHiddenFeesIcon from './images/noHiddenFees.svg'
import crossedFlowerIcon from './images/crossed-flower.svg'
import flowerLoveIcon from './images/flower-love.svg'
import starAllergicIcon from './images/star-allergic.svg'
import starSadIcon from './images/star-sad.svg'
import starLoveIcon from './images/star-love.svg'
import dropCheckedIcon from './images/drop-checked.svg'
import editIcon from './images/edit.svg'
import plainFilterIcon from './images/plain-filter.svg'
import plainSortIcon from './images/plain-sort.svg'
import dollarWithStarIcon from './images/dollar-with-star.svg'

// nav
import candlesIcon from './images/nav/candles.svg'
import cartIcon from './images/nav/cart.svg'
import cartNewIcon from './images/nav/cartNew.svg'
import closeIcon from './images/nav/close.svg'
import collectionsIcon from './images/nav/collections.svg'
import colognesIcon from './images/nav/colognes.svg'
import fragrancesIcon from './images/nav/fragrances.svg'
import freeIcon from './images/nav/free.svg'
import giftsIcon from './images/nav/gifts.svg'
import hamburgerIcon from './images/nav/hamburger.svg'
import bigHamburgerIcon from './images/nav/big-hamburger.svg'
import helpIcon from './images/nav/help.svg'
import homeIcon from './images/nav/home.svg'
import makeupIcon from './images/nav/makeup.svg'
import perfumesIcon from './images/nav/perfumes.svg'
import personalCareIcon from './images/nav/personal-care.svg'
import profileIcon from './images/nav/profile.svg'
import queueIcon from './images/nav/queue.svg'
import skincareIcon from './images/nav/skincare.svg'
import trackingIcon from './images/nav/tracking.svg'
import wellnessIcon from './images/nav/wellness.svg'
import newArrivalsIcon from './images/nav/new.svg'
import recommendationsIcon from './images/nav/recommendations.svg'
import flashSaleIcon from './images/nav/flash-sale.svg'
import tossInIcon from './images/nav/toss-in.svg'
import changeIcon from './images/nav/change.svg'
import aboutIcon from './images/nav/about.svg'
import blogIcon from './images/nav/blog.svg'
import fragranceRecommendationsIcon from './images/nav/fragrance-recommendations.svg'
import howItWorksIcon from './images/nav/how-it-works.svg'
import searchThinIcon from './images/nav/search-thin.svg'
import instagramIcon from './images/nav/instagram.svg'
import instagramNewIcon from './images/nav/instagram-new.svg'
import notificationsIcon from './images/nav/notifications.svg'
import shippingIcon from './images/nav/shipping.svg'
import billingIcon from './images/nav/billing.svg'
import changePasswordIcon from './images/nav/change-password.svg'
import editInformationIcon from './images/nav/edit-information.svg'
import exitIcon from './images/nav/exit.svg'
import contactIcon from './images/nav/contact.svg'
import purchasesIcon from './images/nav/purchases.svg'
import feedbackIcon from './images/nav/feedback.svg'
import backIcon from './images/nav/back.svg'
import searchNewIcon from './images/nav/search-new.svg'
import filterIcon from './images/nav/filter.svg'
import sortIcon from './images/nav/sort.svg'
import catalogIcon from './images/nav/catalog.svg'
import discoveryIcon from './images/nav/discovery.svg'
import favoritesIcon from './images/nav/favorites.svg'
import profileNewIcon from './images/nav/profile-new.svg'
import reviewsWrittenIcon from './images/nav/reviews-written.svg'
import manageSubscriptionIcon from './images/nav/manage-subscription.svg'

// labels
import newLabelImage from './images/labels/new.svg'
import bestsellerLabelImage from './images/labels/bestseller.svg'
import outOfStockLabelImage from './images/labels/out-of-stock.svg'
import limitedEditionLabelImage from './images/labels/limited-edition.svg'


export const miscIcons = {
  dollarWithStar: dollarWithStarIcon,
} as const

export const logoIcons = {
  amazon: amazonIcon,
  apple: appleIcon,
  facebook: facebookIcon,
  facebookCircle: facebookCircleIcon,
  google: googleIcon,
  paypal: paypalIcon,
  paypalLight: paypalLightIcon,
} as const

export const arrowIcons = {
  bottomArrowSmall: bottomArrowSmallIcon,
  leftArrow: leftArrowIcon,
  leftArrowSmall: leftArrowSmallIcon,
  rightArrow: rightArrowIcon,
  rightArrowSmall: rightArrowSmallIcon,
} as const

export const checkmarkIcons = {
  checkmark: checkmarkIcon,
  checkmarkInCircle: checkmarkInCircleIcon,
  checkmarkInEmptyCircle: checkmarkInEmptyCircleIcon,
  checkmarkLong: checkmarkLongIcon,
  checkmarkLight: checkmarkLightIcon,
} as const

export const socialsIcons = {
  messenger: messengerIcon,
  sms: smsIcon,
  smsMessenger: smsMessengerIcon,
  whatsApp: whatsAppIcon,
  instagram: instagramIcon,
  instagramNew: instagramNewIcon,
} as const

export const crossIcons = {
  closeLight: closeLightIcon,
  plusLight: plusLightIcon,
  plus: plusIcon,
} as const

export const roundedIcons = {
  plusInCircle: plusInCircleIcon,
  infoInCircle: infoInCircleIcon,
  question: questionIcon,
  infoInCircleFilled: infoInCircleFilledIcon,
  play: playIcon,
  replay: replayIcon,
  times: timesIcon,
  filledEmptyCircle: filledEmptyCircleIcon,
  plainFilter: plainFilterIcon,
  plainSort: plainSortIcon,
  circleInCircle: circleInCircleIcon,
} as const

export const paymentIcons = {
  creditCard: creditCardIcon,
  lock: lockIcon,
  lockWithKeyHole: lockWithKeyHoleIcon,
} as const

export const infoIcons = {
  like: likeIcon,
  dislike: dislikeIcon,
  heart: heartIcon,
  pencil: pencilIcon,
  search: searchIcon,
  truck: truckIcon,
  star: starIcon,
  link: linkIcon,
  newWindow: newWindowIcon,
  copy: copyIcon,
} as const

export const thumbsIcons = {
  thumbsUp: thumbsUpIcon,
  thumbsDown: thumbsDownIcon,
  thumbsUpSmall: thumbsUpSmallIcon,
  thumbsDownSmall: thumbsDownSmallIcon,
} as const

export const controlIcons = {
  cancel: cancelIcon,
  back: backIcon,
  edit: editIcon,
  close: closeIcon,
  change: changeIcon,
  filter: filterIcon,
  sort: sortIcon,
  hamburger: hamburgerIcon,
  bigHamburger: bigHamburgerIcon,
} as const

export const navigationIcons = {
  profile: profileIcon,
  profileNew: profileNewIcon,
  searchThin: searchThinIcon,
  searchNew: searchNewIcon,
  cart: cartIcon,
  cartNew: cartNewIcon,
  about: aboutIcon,
  home: homeIcon,
  queue: queueIcon,
  gifts: giftsIcon,
  tracking: trackingIcon,
  fragrances: fragrancesIcon,
  wellness: wellnessIcon,
  skincare: skincareIcon,
  candles: candlesIcon,
  help: helpIcon,
  personalCare: personalCareIcon,
  makeup: makeupIcon,
  free: freeIcon,
  newArrivals: newArrivalsIcon,
  collections: collectionsIcon,
  perfumes: perfumesIcon,
  colognes: colognesIcon,
  howItWorks: howItWorksIcon,
  flashSale: flashSaleIcon,
  tossIn: tossInIcon,
  blog: blogIcon,
  fragranceRecommendations: fragranceRecommendationsIcon,
  recommendations: recommendationsIcon,
  catalog: catalogIcon,
  discovery: discoveryIcon,
  favorites: favoritesIcon,
  reviewsWritten: reviewsWrittenIcon,
  notifications: notificationsIcon,
  shipping: shippingIcon,
  billing: billingIcon,
  changePassword: changePasswordIcon,
  editInformation: editInformationIcon,
  contact: contactIcon,
  purchases: purchasesIcon,
  feedback: feedbackIcon,
  exit: exitIcon,
  manageSubscription: manageSubscriptionIcon,
} as const

export const benefitIcons = {
  swapFragrance: swapFragranceIcon,
  freeCalendar: freeCalendarIcon,
  safeCheckout: safeCheckoutIcon,
  stop: stopIcon,
  freeCase: freeCaseIcon,
  travelSize: travelSizeIcon,
  freeShipping: freeShippingIcon,
  noHiddenFees: noHiddenFeesIcon,
  crossedFlower: crossedFlowerIcon,
  flowerLove: flowerLoveIcon,
  starAllergic: starAllergicIcon,
  starSad: starSadIcon,
  starLove: starLoveIcon,
  dropChecked: dropCheckedIcon,
} as const

export const labelIcons = {
  newLabel: newLabelImage,
  bestsellerLabel: bestsellerLabelImage,
  outOfStockLabel: outOfStockLabelImage,
  limitedEditionLabel: limitedEditionLabelImage,
}

export const icons = {
  ...miscIcons,
  ...logoIcons,
  ...arrowIcons,
  ...checkmarkIcons,
  ...socialsIcons,
  ...crossIcons,
  ...roundedIcons,
  ...paymentIcons,
  ...infoIcons,
  ...thumbsIcons,
  ...controlIcons,
  ...navigationIcons,
  ...benefitIcons,
  ...labelIcons,
} as const

export type IconName = keyof typeof icons

export const colors = [ 'black', 'brand', 'white', 'gray', 'gray-30', 'gray-50', 'gray-70', 'gray-80', 'green', 'error' ] as const

export const sizes  = [ 4, 8, 12, 16, 20, 24, 32, 36, 40, 48, 56, 60, 64, 72, 80, 96 ] as const

export type IconColor = typeof colors[number]

export type IconSize = typeof sizes[number]

type IconPropTypes = {
  className?: string
  name: IconName
  size?: IconSize
  color?: IconColor
  alignTop?: boolean
  noWrapper?: boolean
}

const Icon: React.FunctionComponent<IconPropTypes> = (props) => {
  const { className, name, size, color, alignTop, noWrapper } = props

  if (!icons[name]) {
    console.error(`There is no icon with name "${name}"`)
  }

  const rootClassName = cx(s[name], className, {
    [s.alignTop]: alignTop,
    [s[color]]: s[color],
    [s[`size_${size}`]]: size,
  })

  return (
    <InlineSvg
      className={rootClassName}
      src={icons[name]}
      noWrapper={noWrapper}
      cache
    />
  )
}


export default Icon
